import { runtimeEnv } from "config/runtimeEnv";
import { API_ENDPOINT } from "./Api";
import requestInstance from "./Request";
import { setCurrentUser } from "../utils/utils";

let env = runtimeEnv("B2B_API_BASE_URL");

//Profile Service
export const profileService = async () => {
  const res = await requestInstance
    .get(`${env}${API_ENDPOINT.Profile.api}`)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

// Get Dispatch Highlight Thresholds
export const getDispatchHighlightThresholds = async () => {
  const res = await requestInstance
    .get(`${env}${API_ENDPOINT.dispatchHighlightThresholds.api}`)
    .catch((err) => err.response);

  return res;
};
